import {get} from "../modules/ajax";
import {hideModalLoader, openModalFromHtml, showModal, showModalLoader} from "./modal";
import {getImageSizeFromUrl} from "./image";
import {hideElement, showElement} from "./element-visibility";
import {isDesktop, isIOS} from "../modules/devices";
import PinchZoom from "pinch-zoom-js";
import EmblaCarousel from "embla-carousel";

const $body = document.querySelector('body');
const $html = document.querySelector('html');
let scrollPosition = 0;

let emblaMainSlider = null;
let emblaThumbnailSlider = null;

export function addIOSWindowFix()
{
    $html.style.height = 'calc(100vh - 1px)';
    scrollPosition = window.pageYOffset;
    $body.style.overflowY = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';
}

export function clearIOSWindowFix()
{
    $body.style.removeProperty('overflowY');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
    $html.style.removeProperty('height');
}

export function showImageZoomPopup(productId, position)
{
    if (!isDesktop() && isIOS()) addIOSWindowFix();

    let modal = document.getElementById('modal-image-zoom');
    if (modal) {
        showModalLoader(modal);
        if (modal.dataset.productId === productId) {
            if (isDesktop()) removeZoomOfAllDesktopImages();
            hideModalLoader(modal);
            setTimeout(() => emblaMainSlider.scrollTo(position), 200);
        } else {
            getModalImageZoom(productId, true, position);
        }
        showModal('modal-image-zoom');
        if (!isDesktop()) setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
    } else {
        getModalImageZoom(productId, false, position);
    }
}

let ajaxModal = null;
function getModalImageZoom(productId, onlyContent, position)
{
    if (ajaxModal) ajaxModal.abort();
    ajaxModal = get(
        '/ajax/website/product/get-modal-image-zoom',
        {
            productId: productId,
            onlyContent: onlyContent,
        },
        function(response) {
            ajaxModal = null;
            if (onlyContent) {
                let modal = document.getElementById('modal-image-zoom');
                modal.dataset.productId = productId;
                modal.querySelector('#modal-image-zoom-content').innerHTML = response.modal;
                hideModalLoader(modal);
            } else {
                openModalFromHtml(response.modal, {}, false);
            }
            setTimeout(function(){
                loadMainSlider();
                loadThumbnailSlider();
                loadMobileZoom();
                emblaMainSlider.scrollTo(position);
            }, 200);
        },
        function () {
            ajaxModal = null;
        }
    );
}

export async function zoomImage(element, isZoomed)
{
    let image = element.querySelector('img');
    let slider = element.closest('.embla-carousel');
    let imageSize = await getImageSizeFromUrl(image.src);
    let width = imageSize.width;
    let height = imageSize.height;
    let margin = 50;
    let minWidth = slider.offsetWidth + margin;
    let minHeight = slider.offsetHeight + margin;

    if (width <= minWidth && height <= minHeight) element.style.backgroundSize = 'cover';
    if (isZoomed) {
        element.classList.add('zoomed');
        element.style.backgroundImage = `url('${image.src}')`;
        element.style.backgroundRepeat = 'no-repeat';
        hideElement(image);
        element.onmousemove = (event) => {moveImage(event)};
    } else {
        element.classList.remove('zoomed');
        element.style.backgroundImage = '';
        element.style.backgroundRepeat = '';
        setTimeout(function() {
            showElement(image);
        }, 15);
    }
}

function moveImage(e)
{
    let imageZoom = e.currentTarget;
    let offsetX = e.offsetX || null;
    let offsetY = e.offsetY || null;
    if (!offsetX || !offsetY) return;
    let x = offsetX/imageZoom.offsetWidth * 100;
    let y = offsetY/imageZoom.offsetHeight * 100;
    imageZoom.style.backgroundPosition = x + '% ' + y + '%';
}

function loadMobileZoom()
{
    if (isDesktop()) return;
    let images = document.querySelectorAll('#modal-image-zoom .main-slider .touch-zoom');
    let navigationTimeout;
    images.forEach(function(image) {
        new PinchZoom(image, {
            onZoomStart: function(object) {
                emblaMainSlider.reInit({watchDrag: false});
            },
            onZoomUpdate: function(object) {
                emblaMainSlider.reInit({watchDrag: false});
                clearTimeout(navigationTimeout);
                navigationTimeout = setTimeout(function() {
                    let allowNavigation = object.zoomFactor === 1;
                    emblaMainSlider.reInit({watchDrag: allowNavigation});
                }, object.options.animationDuration+150);
            },
            draggableUnzoomed: false
            /*onZoomEnd: function(object) {
                if (object.zoomFactor <= 1) {
                    emblaMainSlider.reInit({ watchDrag: true });
                }
            }*/
        });
    });
}

export function removeZoomOfAllDesktopImages()
{
    let images = document.querySelectorAll('#modal-image-zoom .main-slider .desktop-zoom');
    images.forEach(function(image) {
        zoomImage(image, false);
    });
}

function loadMainSlider()
{
    let slider = document.querySelector('#modal-image-zoom .main-slider');
    let emblaPrevButton = slider.querySelector('.embla-prev-button');
    let emblaNextButton = slider.querySelector('.embla-next-button');
    emblaMainSlider = EmblaCarousel(slider.querySelector('.embla-carousel'));

    //BUTTONS FUNCTIONALITY
    if (emblaMainSlider.canScrollPrev()) emblaPrevButton.classList.remove('d-none');
    if (emblaMainSlider.canScrollNext()) emblaNextButton.classList.remove('d-none');

    emblaPrevButton.addEventListener('click', emblaMainSlider.scrollPrev, false);
    emblaNextButton.addEventListener('click', emblaMainSlider.scrollNext, false);

    emblaMainSlider.on('select', function() {
        if (emblaMainSlider.canScrollPrev() && emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.remove('d-none');
        if (!emblaMainSlider.canScrollPrev() && !emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.add('d-none');
        if (emblaMainSlider.canScrollNext() && emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.remove('d-none');
        if (!emblaMainSlider.canScrollNext() && !emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.add('d-none');
    });
}

function loadThumbnailSlider()
{
    let slider = document.querySelector('#modal-image-zoom .thumbnail-slider');
    let thumbnails = slider.querySelectorAll('.embla-slide');
    emblaThumbnailSlider = EmblaCarousel(slider, {slidesToScroll: 'auto', dragFree: true});

    emblaMainSlider.on('init', function() {
        thumbnails[emblaMainSlider.selectedScrollSnap()].classList.add('active');
    });

    emblaMainSlider.on('select', function() {
        let index = emblaMainSlider.selectedScrollSnap();

        emblaThumbnailSlider.scrollTo(index);
        thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
        thumbnails[index].classList.add('active');
    });

    thumbnails.forEach(function(thumbnail, index) {
        thumbnail.addEventListener('click', function() {
            emblaMainSlider.scrollTo(index);
            thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
            thumbnails[index].classList.add('active');
        });
    });
}